module.exports = __webpack_public_path__ + "img/spritemap.9d1ddfa.svg";